import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Image from 'global/Image';
import { AboutItemContainer } from './styled';

interface AboutProps {
  data: string[];
}

const About = ({ data }: AboutProps) => (
  <>
    <Text size="16px" weight="bold">
      Tentang Obligasi FR
    </Text>
    {data.map((item, idx) => (
      <AboutItemContainer key={`fr-about-item-${idx + 1}`}>
        <Flex align="center">
          <Flex
            align="center"
            justify="center"
            style={{ width: 16, height: 16 }}
          >
            <Image src="/icon/fr/checkmark.svg" />
          </Flex>
          {/* @ts-expect-error */}
          <Text ml="12px">{item}</Text>
        </Flex>
      </AboutItemContainer>
    ))}
  </>
);

export default About;
